import React, { useState } from 'react';
import FormCard from '@/components/Layouts/Default/FormCard';
import { NextUI } from '@/components/NextUI';
import { showSide } from '@/store/slices/sideSlice';
import { useAppDispatch } from '@/hooks/redux';
import SideLabel from '@/components/Common/Sides/partials/SideLabel';
import SideLayout from '@/components/Common/Sides/partials/SideLayout';
import SideDescription from '@/components/Common/Sides/partials/SideDescription';
import ProSide from '@/components/Common/Sides/partials/ProSide';

const Try7Days = () => {
  const today = new Date();
  const dispatch = useAppDispatch();

  const futureDate7Days = new Date(today);
  futureDate7Days.setDate(today.getDate() + 7);

  const futureDate1Month = new Date(today);
  futureDate1Month.setMonth(today.getMonth() + 1);

  const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
    };
    return date.toLocaleDateString('en-US', options);
  };

  const [activeCard, setActiveCard] = useState<'monthly' | 'yearly'>('monthly');

  return (
    <div className="w-full flex">
      <div className="flex min-h-dvh w-full flex-col items-center justify-center">
        <SideLayout className="py-3 !max-w-[624px] !w-full">
          <SideLabel label="Start Your Free 7-Day Trial Today! " />
          <SideDescription text="Enjoy Unlimited Access to All Premium Tools and Features for 7 Days – Completely Free!" />

          <div className="hidden md:flex items-center mt-2 text-[13px] px-2">
            <div className="flex-1 flex flex-col items-center justify-center gap-1">
              <span className="text-gray-medium">
                Today - {formatDate(futureDate7Days)}
              </span>
              <div className="relative h-1 bg-primary-extra-light-blue w-full">
                <div className="absolute -left-2 top-1/2 transform -translate-y-1/2 h-3 w-3 bg-primary-extra-light-blue rounded-full"></div>
              </div>
              <span className="text-gray-dark font-medium">Free 7 Days</span>
            </div>
            <div className="w-[40%] flex flex-col items-center gap-1 justify-center">
              <span className="text-gray-medium">
                {formatDate(futureDate7Days)} - {formatDate(futureDate1Month)}
              </span>
              <div className="h-1 bg-primary-light-blue w-full relative">
                <div className="absolute -left-2 top-1/2 transform -translate-y-1/2 h-3 w-3 bg-primary-light-blue rounded-full"></div>
                <div className="absolute -right-2 top-1/2 transform -translate-y-1/2 h-3 w-3 bg-primary-light-blue rounded-full"></div>
              </div>
              <span className="text-gray-dark font-medium">Pro</span>
            </div>
          </div>

          <ul className="hidden md:block list-disc list-inside text-[15px] text-gray-medium text-center w-full mt-2">
            <li>
              An email with your trial details will be sent to you shortly.
            </li>
            <li>
              You will not be charged now – enjoy your first 7 days free of
              cost.
            </li>
            <li>Save 25% by choosing the annual plan! Get 3 months free.</li>
            {/* <li>
          You pay <span className="font-semibold">USD 0,00</span> now. Set up
          payment for later.
        </li> */}
          </ul>

          <div className="flex flex-col md:flex-row justify-center w-full mt-2 gap-2 ">
            <div
              onClick={() => setActiveCard('monthly')}
              className={`!rounded-extra cursor-pointer flex-1 w-full shadow-none border-1 ${
                activeCard === 'monthly'
                  ? 'border-primary-light-blue  bg-primary-extra-light-blue2'
                  : 'border-gray-medium2 bg-gray-very-light'
              }`}
            >
              <div className="!p-1.5 flex flex-col items-center justify-start">
                <p className="font-bold text-dark text-[17px]">Monthly</p>
                <p className="text-[13px] text-gray-medium">USD 12 / Month</p>
              </div>
            </div>
            <div
              onClick={() => setActiveCard('yearly')}
              className={`!relative !overflow-visible !rounded-extra cursor-pointer flex-1 w-full shadow-none border-1 ${
                activeCard === 'monthly'
                  ? 'border-gray-medium2 bg-gray-very-light'
                  : 'border-primary-light-blue  bg-primary-extra-light-blue2'
              }`}
            >
              <div className="!p-1.5 !overflow-visible flex flex-col items-center justify-start">
                <p className="font-bold text-dark text-[17px]">Yearly</p>
                <p className="text-[13px] text-gray-medium text-center">
                  USD 9 / Month <br />
                  <span className="text-gray-light">
                    Billed USD 108 Annually
                  </span>
                </p>
                <div className="-top-2 !z-50 absolute text-[11px] font-medium text-white bg-[#31CA93] rounded-[3px] px-1">
                  3 Month Free
                </div>
              </div>
            </div>
          </div>

          <FormCard
            classNames={{
              formBody: '!px-0 !w-full',
              actionWrapper: '!p-0',
            }}
            isAction={false}
          >
            <div className="grid md:grid-cols-2 gap-2 mt-2">
              <NextUI.Input
                name="firstName"
                type="text"
                formNoValidate
                variant="outline"
                radius="sm"
                placeholder="First Name"
                classNames={{
                  inputWrapper: 'h-10',
                }}
              />
              <NextUI.Input
                name="lastName"
                type="text"
                formNoValidate
                variant="outline"
                radius="sm"
                placeholder="Last Name"
                classNames={{
                  inputWrapper: 'h-10',
                }}
              />
            </div>

            <div className="flex mt-2 border border-gray-light2 rounded-extra">
              <div className="flex-grow">
                <NextUI.Input
                  name="cardNumber"
                  type="text"
                  formNoValidate
                  variant="outline"
                  radius="sm"
                  placeholder="Card Number"
                  classNames={{
                    inputWrapper: '!border-none !rounded-extra h-10',
                    input: 'flex-grow outline-none',
                  }}
                />
              </div>

              <div className="flex space-x-2">
                <NextUI.Input
                  name="expiry"
                  type="text"
                  formNoValidate
                  variant="outline"
                  radius="sm"
                  placeholder="MM / YY"
                  classNames={{
                    inputWrapper:
                      'w-[80px] p-2 outline-none !border-none !rounded-extra h-10',
                    input: 'w-[80px] outline-none',
                  }}
                  maxLength={4}
                />
                <NextUI.Input
                  name="cvc"
                  type="text"
                  formNoValidate
                  variant="outline"
                  radius="sm"
                  placeholder="CVC"
                  classNames={{
                    inputWrapper:
                      '!border-none w-[60px] outline-none !rounded-extra h-10',
                    input: 'w-[60px] outline-none',
                  }}
                  maxLength={3}
                />
              </div>
            </div>

            <div className="text-center mt-2 text-[15px] text-gray-dark">
              Total due in free trial:{' '}
              <span className="font-semibold">USD 0,00</span>
            </div>

            <NextUI.Button
              className="w-full h-10 mt-2"
              onClick={() => dispatch(showSide({ sideKey: 'try7DaysOk' }))}
            >
              Start Your Free Trial Now
            </NextUI.Button>
          </FormCard>

          <p className="text-xs text-gray-light text-center mt-2">
            Start your 7-day free trial today and unlock all premium features
            until {formatDate(futureDate7Days)}. Cancel anytime, or continue
            enjoying PDF Genius Pro for just{' '}
            {activeCard === 'monthly' ? '12' : '9'} / month – no interruptions
            to your access!
          </p>
        </SideLayout>
      </div>
      {/* <ProSide /> */}
    </div>
  );
};

export default Try7Days;
